import React from 'react';

const Spacer = () => (
    <>
        <div
            style={{
                flexGrow: 1,
            }}
        ></div>
    </>
);

export default Spacer;
